export default __webpack_public_path__ + "static/media/doctorTAP.95f3038a.svg";